import React from 'react';
import { AdminGuard } from '../components/admin/AdminGuard';
import { AdminPanel } from '../components/admin/AdminPanel';

export default function AdminPage() {
  return (
    <AdminGuard>
      <AdminPanel />
    </AdminGuard>
  );
}
